/*
 * @Author       : didi
 * @Date         : 2022/1/19 10:48 上午
 * @Description  : 
 */


import { mpx } from '@didi/es-mpx-creator'
import {
  MAKE_PAY,
  ORDER_DETAIL,
  CANCEL_TRIP_BEFORE,
  DEAL_DETAIL,
  OFFLINE_REFUND_FEE_DETAIL,
  OFFLINE_REFUND_MONEY,
  MAKE_PACKAGE,
  MAKE_EXTRA_PAY,
  GET_SHARE_INFO
} from '../urls';

export const makePay = (data) => {
  return mpx.$http.post(
    MAKE_PAY,
    { data }
  )
}
export const cancelOrder = (data) => {
  return mpx.$http.post(
    CANCEL_TRIP_BEFORE,
    { data }
  )
}
export const getTrainOrderDetail = (data) => {
  return mpx.$http.post(
    ORDER_DETAIL,
    { data }
  )
}
export const getDealDetail = (data) => {
  return mpx.$http.post(
    DEAL_DETAIL,
    { data }
  )
}
export const getOfflineRefundFeeDetail = (data) => {
  return mpx.$http.post(
    OFFLINE_REFUND_FEE_DETAIL,
    { data }
  )
}
export const applyOfflineRefund = (data) => {
  return mpx.$http.post(
    OFFLINE_REFUND_MONEY,
    { data }
  )
}
export const makePackage = data => {
  return mpx.$http.post(MAKE_PACKAGE, { data });
};
export const makePackagePay = data => {
  return mpx.$http.post(MAKE_EXTRA_PAY, { data });
};
export const getShareInfo = data => {
  return mpx.$http.post(GET_SHARE_INFO, { data });
};
